// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3K3fl","list":"PatternAutocomplete_list__PnJye"};